import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

export function useDriverNotifications() {
  const { currentUser } = useAuth();
  const [notification, setNotification] = useState(null);
  const [notifId, setNotifId] = useState(null);

  useEffect(() => {
    if (!currentUser) return;

    const q = query(
      collection(db, 'notifications'),
      where('uid', '==', currentUser.uid),
      where('read', '==', false)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added') {
          setNotifId(change.doc.id);
          setNotification(change.doc.data());
        }
      });
    });

    return unsubscribe;
  }, [currentUser]);

  function dismiss() {
    setNotification(null);
    setNotifId(null);
    if (notifId) {
      updateDoc(doc(db, 'notifications', notifId), { read: true })
        .catch((err) => console.error('[useDriverNotifications] mark read failed:', err));
    }
  }

  return { notification, dismiss };
}
